export function setCurrentUser(token,user) {
	return {
				type: 'AUTH_SET_CURRENT_USER',
				payload:{token,user}
			}
}

export function setGlobalKey(key,value) {
	return {
				type: 'AUTH_SET_GLOBAL_KEY',
				payload:{key,value}
			}
}

export function setCurrentAccount(account_id) {
	return {
				type: 'AUTH_SET_CURRENT_ACCOUNT',
				payload:account_id
			}
}

export function setConnectionStatus(status) {
	return {
				type: 'AUTH_SET_CONNECTION_STATUS',
				payload:status
			}
}
export function setUserSetting(key,value) {
	return {
				type: 'UPDATE_SETTING_KEY',
				payload:{
					key,value
				}
			}
}

export function setLoadedVisitors(status) {
	return {
				type: 'AUTH_SET_LOADED_VISITORS',
				payload:status
			}
}

export function setUserKey(key,value) {
	return {
				type: 'AUTH_SET_USER_KEY',
				payload:{key,value}
			}
}



// WEBPACK FOOTER //
// ./actions/Login.js